// extracted by mini-css-extract-plugin
export default {"container":"Carrosel_container__E0Rbh","swiper-container":"Carrosel_swiper-container__obibv","swiper-slide":"Carrosel_swiper-slide__a5yrI"};